import { createPaginatedInfiniteQuery, type QueryApi } from "../../api/query";

export function createUseProjectSearch($api: QueryApi) {
  const usePaginatedInfiniteQuery = createPaginatedInfiniteQuery($api);

  return function useProjectSearch(params: { searchTerm: string; size?: number }) {
    return usePaginatedInfiniteQuery(
      "/projects/search",
      { searchTerm: params.searchTerm, size: params.size ?? 20 },
      { enabled: params.searchTerm.length >= 2, staleTime: 30_000 },
    );
  };
}
